import React from 'react'

export default function Logo() {
  return (
    <div >
        <div>
          <div style={{ display:'inline-block'}} >
            <img height={40}  src='https://img1.wsimg.com/isteam/ip/dc190deb-86b3-4414-a186-9cc686df12c8/thumbnail_logo-super-tools%20(1).png' alt=''></img> 
          </div>
          
          <div  className='pt-3' style={{ display:'inline-block' , height:'30px' , verticalAlign : 'buttom'}}>
            <p className='pb-0 mb-0'  style={{fontSize:'12px' }}>1980</p>
          </div>
            
          
        </div>
        
    </div>
  )
}
